<template>
  <div id="app">
    <v-app>
      <div class="flexparent">
        <div id="treeparent">
          <mdn-tree-view :treedata="treedata"
                         :verbose="verbose"
                         :sort-nodes="sortNodes"
                         :expand-all="expandAll"
                         drag-background-color="#666"
                         @itemclick="handleClick"
                         @datachanged="printData">
          </mdn-tree-view>
        </div>
        <div id="outputcontainer">
            <v-btn absolute dark ripple class="resetBtn" v-on:click="resetData">reset to sample data</v-btn>
            <v-btn absolute dark ripple class="useDataBtn" v-on:click="useData">use textfield data</v-btn>
            <v-btn absolute dark ripple class="sortNodesBtn" v-on:click="toggleSortNodes">sort alphabetical: {{sortNodes}}</v-btn>
            <v-btn absolute dark ripple class="expandAllBtn" v-on:click="toggleExpandAll">expand nodes: {{expandAll}}</v-btn>
          <textarea id="output" v-model="stringData"></textarea>
        </div>
      </div>
    </v-app>
  </div>
</template>

<script>
import MdnTreeView from './components/MdnTreeView'

export default {
  name: 'app',
  data: function () {
    return {
      treedata: [],
      stringData: "",
      verbose: true,
      sortNodes: true,
      expandAll: false
    }
  },
  mounted() {
    this.resetData()
  },
  watch: {
    treedata: function(newVal, oldVal) {
      this.printData(newVal)
    }
  },
  methods: {
    resetData: function() {
      this.treedata = JSON.parse(JSON.stringify(window.SAMPLE_DATA)) //deep copy
    },
    useData: function() {
      this.treedata = JSON.parse(this.stringData)
    },
    printData: function(data) {
      this.stringData = JSON.stringify(data, null, 2)
    },
    toggleSortNodes: function() {
      this.sortNodes = !this.sortNodes
    },
    toggleExpandAll: function() {
      this.expandAll = !this.expandAll
    },
    handleClick: function(node, command) {
      console.log('tree-click-event', 'command: '+ command, node)
    }
  },
  components: {
    MdnTreeView
  }
}
</script>

<style>
  *, *:before, *:after {
    box-sizing: border-box;
  }

  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }
  .flexparent {
    display:flex;
    padding: 20px;
    background: #666;
  }

  #treeparent {
    flex: 1;
    height: calc(100vh - 40px);
    margin-right: 1em;
  }

  #outputcontainer {
    height: calc(100vh - 40px);
    flex: 2;
  }
  #output {
    width: 100%;
    height: 100%;
    background: #aaa;
    border: 1px solid #222;
    overflow:auto;
    padding: 20px;
    outline: none;
  }


  .useDataBtn {
    top: 30px;
    right: 44px;
    width: 200px;
  }

  .resetBtn {
    top: 70px;
    right: 44px;
    width: 200px;
  }

  .sortNodesBtn {
    top: 110px;
    right: 44px;
    width: 200px;
  }

  .expandAllBtn {
    top: 150px;
    right: 44px;
    width: 200px;
  }

  ::-webkit-scrollbar-track
  {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    background-color: #444;
  }

  ::-webkit-scrollbar
  {
    width: 12px;
    background-color: #F5F5F5;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #000000;
    border: 0px solid #555555;
  }

  .v-btn {
    text-transform: lowercase;
  }

  #app .tree-default .tree-selected {
    background: #555;
  }

  #app .tree-default .tree-selected .mdnGray {
    color: #999;
  }

  #app .tree-default .tree-hovered {
    background: #555;
  }
</style>
